import api from "./index";

export const getCrawlerProperties = (params = {}) =>
  api.get(`property-crawler/property-items/`, { params });

export const postCrawlerProperty = (data) =>
  api.post(`property-crawler/property-items/`, data);
export const getSpecificCrawlerProperty = (id) =>
  api.get(`property-crawler/property-items/${id}/`);

export const putCrawlerProperty = (id, data) =>
  api.put(`property-crawler/property-items/${id}/`, data);

export const deleteCrawlerProperty = (id) =>
  api.delete(`property-crawler/property-items/${id}/`);
